<template>
  <div>
  <v-card class="mx-auto objectCard">
      <v-sheet class="pa-3 primary">
        <v-layout row justify-space-between>
          <v-flex xs1>
            <v-btn class="setRefreshBtn pa-2" large color="secondary" @click="refreshActivated()"><v-icon>cached</v-icon></v-btn>
          </v-flex>
          <v-flex xs9>
            <v-text-field
              v-model="search"
              label="Search object"
              dark
              flat
              solo-inverted
              hide-details
              clearable
              clear-icon="mdi-close-circle-outline"
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-btn class="setRefreshBtn pa-2" large color="secondary" @click="reloadDRH()">reload DRH</v-btn>
          </v-flex>
        </v-layout>
      </v-sheet>
      <v-layout
        justify-space-between
        pa-3
      >
        <v-flex xs5>
          <v-card class="treeViewCard elevation-0 transparent">
            <v-treeview
            :active.sync="active"
            :items="items"
            :open.sync="open"
            :search="search"
            :filter="filter"
            item-key="id"
            item-text="Description"
            activatable
            active-class="primary--text"
            class="grey lighten-5"
            transition
          >
            <template v-slot:prepend="{ item, active }">
              <v-icon
                v-if="!item.children"
                :color="active ? 'primary' : ''"
              >
                mdi-account
              </v-icon>

              <div class="divvie" :style="`background-color: ${setBackgroundColor(item)}`">
              </div>
            </template>
          </v-treeview>
          </v-card>
        </v-flex>
        <v-flex
          d-flex
          text-xs-center
        >
          <v-scroll-y-transition mode="out-in">
            <div
              v-if="!selected"
              class="title grey--text text--lighten-1 font-weight-light"
              style="align-self: center;"
            >
              Select a Object
            </div>
            <v-card
              v-else
              :key="selected.id"
              class="pt-4 mx-auto managementCard"
              flat
              max-width="400"
            >
              <v-card-text>
                <h3 class="headline mb-2">
                  {{ selected.Description }}
                </h3>
                <v-layout row>
                  <h3 style="width: 50%;">Object ID : </h3>
                  <v-card style="width: 50%;" class=" transparent elevation-0 blue--text subheading font-weight-bold"><h3>{{ selected.name }}</h3></v-card>
                </v-layout>
                <v-layout row>
                  <h3 style="width: 50%;">Current LogLevel : </h3>
                  <v-card style="width: 50%;" class=" transparent elevation-0 blue--text subheading font-weight-bold"><h3>{{ selected.LogLevel }}</h3></v-card>
                </v-layout>
                <v-layout row>
                  <h3 style="width: 50%;">Current TO state : </h3>
                  <v-card style="width: 50%;" class=" transparent elevation-0 blue--text subheading font-weight-bold"><h3>{{ selected.ToState }}</h3></v-card>
                </v-layout>
                <v-layout row>
                  <h3 style="width: 50%;">Type : </h3>
                  <v-card style="width: 50%;" class=" transparent elevation-0 blue--text subheading font-weight-bold"><h3>{{ selected.Type }}</h3></v-card>
                </v-layout>
                <v-divider v-if="selected.name === 'LocationsNode'"></v-divider>
                <v-btn color="primary" class="ma-2"  v-if="selected.name === 'LocationsNode'" @click="triggerSaveShutdown">Savely shutdown</v-btn>
                <v-divider></v-divider>
                <v-btn color="primary" class="ma-2" @click="triggerSetLogLevelDialog">Change Log level</v-btn>
                <v-divider></v-divider>
                <v-btn color="secondary" class="ma-2" @click="stopObjectDialog = true">Stop Object</v-btn>
                <v-btn color="primary" class="ma-2" @click="startObjectDialog = true">Start Object</v-btn>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-scroll-y-transition>
        </v-flex>
      </v-layout>
    <v-dialog v-model="setLogLevelDialog" persistent max-width="350">
      <v-card class="generic_dialog_class">
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >Changing log level for : {{selectedItem.name}}</v-card-title>
        <v-card-text>
          <h3>Current Log level is : <b>{{selectedItem.LogLevel}}</b></h3>
          <v-layout row>
            <v-flex xs6>
          <v-text-field
            required
            type="number"
            min="0"
            max="6"
            label="Set log level to: "
            v-model="logLevelObject.LogLevel"
          ></v-text-field>
            </v-flex>
            <v-flex xs5>
            <v-checkbox
              class="ml-2"
              required
              label="Recursive "
              v-model="logLevelObject.Recursive"
            ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="setLogLevelDialog = false"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn
            color="primary"
            round
            class="text-capitalize"
            @click="changeLogLevel(logLevelObject)"
          >{{$translate('SAVE')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="setShutdownDialog" persistent max-width="350">
      <v-card class="generic_dialog_class">
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{selectedItem.name}}</v-card-title>
        <v-card-text>
          <h3>Are you sure you want to savely shutdown : {{ selectedItem.name }}</h3>
          <v-divider></v-divider>
          <p>This process will take several minutes</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="setShutdownDialog = false"
          >NO</v-btn>
          <v-btn
            color="primary"
            round
            class="text-capitalize"
            @click="saveShutdown()"
          >YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="stopObjectDialog" persistent max-width="350">
      <v-card class="generic_dialog_class">
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{selectedItem.name}}</v-card-title>
        <v-card-text>
          <h3>Are you sure you want to stop object: {{ selectedItem.name }}</h3>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="stopObjectDialog = false"
          >NO</v-btn>
          <v-btn
            color="primary"
            round
            class="text-capitalize"
            @click="exitRunning()"
          >YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="startObjectDialog" persistent max-width="350">
      <v-card class="generic_dialog_class">
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{selectedItem.name}}</v-card-title>
        <v-card-text>
          <h3>Are you sure you want to savely shutdown : {{ selectedItem.name }}</h3>
          <v-divider></v-divider>
          <p>This process will take several minutes</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="startObjectDialog = false"
          >NO</v-btn>
          <v-btn
            color="primary"
            round
            class="text-capitalize"
            @click="initRunning()"
          >YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
    <v-card v-if="debugMode" class="mx-auto countCard">
      <v-sheet class="pa-4 primary counting">
        <h2 style="color:white"> Object counts</h2>
      </v-sheet>
        <v-card class="elevation-10 scrollCountCard">
            <v-layout class="mt-2 mb-2" column align-center>
                <v-layout column >
                  <v-flex xs8 style="background-color:#FAFAFA">
                    <v-layout column v-for="(key, value) of objectCounts" :key="index" style=" font-weight: bold" class="valueName">
                    <p>{{value}}:</p>
                    <p>{{key}}</p>
                      </v-layout>
                  </v-flex>
                </v-layout>
            </v-layout>
          <v-divider dark></v-divider>
        </v-card>
    </v-card>
  </div>
</template>

<script>
import * as dssRequest from "../api/dssRequest";
import appConfig from "../../config/app_config";
import BaseObject from "../objects/BaseObject";

export default {
  name: "ObjectManagement",
  data() {
    return {
      //dialogs
      setLogLevelDialog: false,
      setShutdownDialog: false,
      stopObjectDialog: false,
      startObjectDialog: false,
      debugMode: appConfig.DEBUG,
      logLevelObject: {},
      search: null,
      caseSensitive: false,
      active: [],
      open: [],
      loopNumb: 0,
      items: [],
      objectCounts: {},
      selectedId: '',
      selectedItem: {}
    };
  },
  computed: {
    filter () {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined
    },
    selected() {
      if (!this.active.length) return undefined;
      this.selectedId = this.active[0];
      this.selectedItem = this.recursivelySearchForId(this.items[0]);
      return this.selectedItem;
    }
  },
  // watch: {
  //   selected: 'randomAvatar'
  // },
  mounted() {
    this.getObjectInfo();
    // this.getObjectCounts();
  },
  methods: {
    initRunning() {
      const payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for initRunning on the management screen was successful",
            response
          );
          this.startObjectDialog = false;
          this.getObjectInfo();

        },
        error => {
          console.log(
            "The call for initRunning on the management was not successful",
            error
          );
        },
        "initRunning",
        this.selectedItem.name,
        payload
      );
    },
    exitRunning() {
      const payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for exitRunning on the management screen was successful",
            response
          );
          this.stopObjectDialog = false;
          this.getObjectInfo();

        },
        error => {
          console.log(
            "The call for exitRunning on the management was not successful",
            error
          );
        },
        "exitRunning",
        this.selectedItem.name,
        payload
      );
    },
    triggerSaveShutdown() {
      this.setShutdownDialog = true;
    },
    saveShutdown() {
      this.setShutdownDialog = false;
      const payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for saveShutdown on the management screen was successful",
            response
          );
          this.setShutdownDialog = false;
          this.getObjectInfo();

        },
        error => {
          console.log(
            "The call for saveShutdown on the management was not successful",
            error
          );
        },
        "saveShutdown",
        this.selectedItem.name,
        payload,
        60000,
        false
      );
    },
    triggerSetLogLevelDialog() {
      this.logLevelObject = {};
      this.setLogLevelDialog = true;
    },
    changeLogLevel(item) {
      if (!item.hasOwnProperty('Recursive')) {
        item.Recursive = false;
      }

      const payload = {
        LogLevel: Number(item.LogLevel),
        Recursive: item.Recursive
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for changeLogLevel on the management screen was successful",
            response
          );
          this.setLogLevelDialog = false;
          this.getObjectInfo();

        },
        error => {
          console.log(
            "The call for changeLogLevel on the management was not successful",
            error
          );
        },
        "setLogging",
        this.selectedItem.name,
        payload
      );
    },
    setBackgroundColor(item) {
      if (item.ToState === 2) {
        return '#299617';
      } else if (item.ToState === 1) {
        return '#2243B6';
      } else {
        return '#FD0E35';
      }
    },
    recursivelySearchForId(obj) {
      // Recursively search through the items for an ID
        if (obj.id === this.selectedId) {
          return obj;
        } else {
          if (obj.hasOwnProperty('children')) {
            for (let i = 0; i < obj.children.length; i++) {
              let tmpObj = {};
              tmpObj = this.recursivelySearchForId(obj.children[i]);
              if (!_.isEmpty(tmpObj)) {
                return tmpObj;
              }
            }
          } else {
            return {};
          }
        }
    },
    getObjectCounts() {
      // Retrieving the objects counts
      const payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for objectCounts on the management screen was successful",
            response
          );
          this.objectCounts = {};
          this.objectCounts = response.data;
        },
        error => {
          console.log(
            "The call for objectCounts on the management was not successful",
            error
          );
        },
        "objectCounts",
        "LocationsNode",
        payload
      );
    },
    refreshActivated() {
      this.getObjectInfo();
      this.getObjectCounts();
    },
    reloadDRH() {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for reload on the management screen was successful",
            response
          );
          this.stopObjectDialog = false;
          this.getObjectInfo();

        },
        (error) => {
          console.log(
            "The call for reload on the management was not successful",
            error
          );
        },
        "reload",
        'LocationsNode_DRH',
        payload
      );
    },
    getObjectInfo() {
      // Retrieving the full LocationsNode and her objects
      const payload = {};
      dssRequest.doRequest(
        response => {
          console.log(
            "The call for getObjectInfo on the management screen was successful",
            response
          );
          this.active = [];
          this.items = [];
          this.eachRecursive(response.data.LocationsNode);
          response.data.LocationsNode.name = 'LocationsNode';
          this.items.push(response.data.LocationsNode);
          },
        error => {
          console.log(
            "The call for getObjectInfo on the management was not successful",
            error
          );
        },
        "getObjectInfo",
        "LocationsNode",
        payload
      );
    },
    eachRecursive(obj) {

      // this.loopCounter++;
      //
      // if (this.loopCounter > 10) {
      //   return;
      // }
        this.loopNumb = this.loopNumb + 1;
        let tmpChildren = [];
        for (let [key, value] of Object.entries(obj)) {
          if (typeof(value) === "object") {
            tmpChildren.push(value);
            value.name = key;
            delete obj[key]
          } else {
          }
        }
        obj.id = this.loopNumb;
        // return;
        if (tmpChildren.length > 0) {
          obj.children = [];
          tmpChildren.forEach(( e => {
            obj.children.push(e);
            this.eachRecursive(e);
          }))
        } else {
          return;
        }
    },
  }
};
</script>


<style lang="scss" scoped>
  .divvie {
    height: 1.5em;
    width: 1.5em;
    border-radius: 50%;
    border: 1px solid black;
  }

  .treeViewCard {
    max-height: 27em;
    overflow-y: auto;
    overflow-x: auto;
  }

  .objectInfo {
    min-height: 5em;
  }

  .objectCard {
    min-height: 35em;
    max-height: 40em;
    margin-top: 5em !important;
    margin-bottom: 5em !important;
  }

  .countCard {
    max-height: 40em;
    margin-bottom: 5em !important;
  }
  .valueName{
    margin-left: 2em;
    margin-bottom: 2em;
  }
  .scrollCountCard {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 35em;
    min-width: 100%;
  }

  .setRefreshBtn {
    margin-top: 0.1em;
  }

  .managementCard {
    max-height: 25em;
    overflow-y: auto;
    overflow-x: hidden;
  }
</style>
